import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import { YEREL_DEMO } from '../demo/yerelDemoKipi';
import type { PanelConfig } from '../types/panelConfig';

// apiClient already injects auth headers (X-Api-Key for demo, Bearer for
// real-firm panels via createBearerAuthClient interceptor). No manual header
// wiring needed here.
export function usePanelConfig() {
  return useQuery<PanelConfig>({
    queryKey: ['panelConfig'],
    queryFn: async () => {
      // S334 yerel demo: yapılandırma da ağa çıkmadan gelir.
      if (YEREL_DEMO) return (await import('../demo/yerelDemo')).yerelPanelConfig();
      const { data } = await apiClient.get('/api/v2/panel/config');
      return data;
    },
    staleTime: 1000 * 60 * 10,
    retry: 2,
  });
}
